import { render, staticRenderFns } from "./NewsCategoryControl.vue?vue&type=template&id=7579b928&"
import script from "./NewsCategoryControl.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports